module.exports = __webpack_public_path__ + "img/line_paytable.7cf963bc.png";